import React, { useEffect } from 'react';
import
{
    Box, TextField, Button, MenuItem, Select,
    // MenuItem,
    // Select,
    // InputLabel,
} from '@mui/material';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
// import trash from '../../assets/images/trash.svg';
import { useState, Downgraded } from '@hookstate/core';
import CircularProgress from '@mui/material/CircularProgress';
// import DataList from '../../sharedcomponents/dataList/dataList';
// import CKEditor from 'ckeditor4-react';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
// import EditTemplate from '../../modules/Invitation/editTemplate';
import { makeStyles } from '@mui/styles';
// import validator from 'validator';
// import { useParams } from 'react-router-dom';
// import FormControl from '@mui/material/FormControl';
// import OutlinedInput from '@mui/material/OutlinedInput';

import { FULL_PERMISSION } from '../../constants/Constant';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DataTicketSettingList from './settingData/dataTicketSettingList';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import Editor from 'ckeditor5-custom-build/build/ckeditor';
import CancelIcon from '@mui/icons-material/Cancel';

const useStyles = makeStyles({
    // mobileLogo: {
    //     height: 42,
    // },
    // sedanBlack: {
    //     height: 18,
    //     width: 36,
    // },
    // loader: {
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //     height: '100%',
    //     width: '100%',
    // },
    inputNumber: {
        '& input[type=number]': {
            '-moz-appearance': 'textfield'
        },
        '& input[type=number]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        },
        '& input[type=number]::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        }
    },
});

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

// const settingState = createState({
//     name: '',
//     date: '',
// });

// const Status = [
//     {
//         value: 0,
//         label: 'InActive',
//     },
//     {
//         value: 1,
//         label: 'Active',
//     },
// ];
const Settings = () =>
{
    const classes = useStyles();
    const loading = useState(false);
    const settingList = useState([]);
    const openDialog = useState(false);
    // const state = useState(settingState);
    const eventData = useState(null);
    // const openTemplateDialog = useState(false);
    const ticketInfo = useState(null);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [flag, setFlag] = React.useState(false);
    const userInfo = useState(null);
    const inputArr = [
        {
            ticketMasterID: 0,
            ticketSubTypeID: 1,
            ticketNightID: 1,
            price: 0
        },
    ];
    const satInputArr = [
        {
            ticketMasterID: 0,
            ticketSubTypeID: 1,
            ticketNightID: 2,
            price: 0
        },
    ];
    const sunInputArr = [
        {
            ticketMasterID: 0,
            ticketSubTypeID: 1,
            ticketNightID: 3,
            price: 0
        },
    ];
    const [dynamicFriTypePrice, setDynamicFriTypePrice] = React.useState(inputArr);
    const [dynamicSatTypePrice, setDynamicSatTypePrice] = React.useState(satInputArr);
    const [dynamicSunTypePrice, setDynamicSunTypePrice] = React.useState(sunInputArr);


    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });

    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    useEffect(() =>
    {
        const guserInfo = Helper.getStorage('userInfo');
        userInfo.set(guserInfo);
        resetState();
    }, []);
    useEffect(() =>
    {
        const eventInfo = Helper.getStorage('eventInfo');
        if (
            eventData.get() == null ||
            (eventData.get() && eventData.eventID.value != eventInfo.eventID)
        )
        {
            eventData.set(eventInfo);
        }
        getSettingsList();
    }, []);
    const resetState = () =>
    {
        setDynamicFriTypePrice(inputArr)
        setDynamicSatTypePrice(satInputArr)
        setDynamicSunTypePrice(sunInputArr)
    };

    const getSettingsList = () =>
    {
        loading.set(true);
        let usersData = [];
        ApiHelper.get(APIURLConstants.GET_TICKET_ALLSTAR_SETTING(eventData.get().eventID))
            .then((res) =>
            {
                let data = res.data.rows;
                if (data.length > 0)
                {
                    data.map((item, i) =>
                    {
                        // console.log(item);
                        usersData.push({
                            actualData: item,
                            row: [
                                {
                                    label: 'checkbox',
                                    key: 'ticketMasterID',
                                    ticketMasterID: item.ticketMasterID,
                                    width: '0.03',
                                },

                                {
                                    label: 'Master Request',
                                    key: 'masterRequest',
                                    masterRequest: 'Master Request' + i,
                                    showLabel: false,
                                    width: '0.30',
                                },

                                // {
                                //     label: 'Date',
                                //     key: 'date',
                                //     date: Helper.FormatDate(item.date),
                                //     width: '0.30',
                                //     inColumn: true
                                // },
                                {
                                    label: 'Action',
                                    key: 'edit',
                                    edit: 'Edit',
                                    width: '0.02',
                                },

                                { showChips: true },
                            ],
                            expanded: false,
                            selected: false,
                        });
                    });
                }
                settingList.set(usersData);
                loading.set(false);
            })
            .catch((err) =>
            {
                console.log(err);
                loading.set(false);
            });
    };
    const toggleChange = (item, index) =>
    {
        item.expanded = !item.expanded;
        settingList[index].set(item);
    }
    const redirectToCreate = () =>
    {
        openDialog.set(true);
    };
    // const handleClose = () =>
    // {
    //     openDialog.set(false);
    // };
    const editTicket = (info) =>
    {
        // console.log("info",info);
        // openTemplateDialog.set(true);
        ticketInfo.set(info.actualData);

        let editData = info.actualData;
        // console.log("editData".editData);
        // state.set({
        //     name: editData.name,
        //     date: editData.date,
        // })
        let friData = [];
        let satData = [];
        let sunData = [];

        editData.prices.map((value) =>
        {
            if (value.ticketNightID === 1)
            {
                friData.push(value)
            } else if (value.ticketNightID === 2)
            {
                satData.push(value)
            } else if (value.ticketNightID === 3)
            {
                sunData.push(value)
            }
        })
        setDynamicFriTypePrice(friData)
        setDynamicSatTypePrice(satData)
        setDynamicSunTypePrice(sunData)
        openDialog.set(true);
    };

    const deleteSettingsList = () =>
    {
        const selected = settingList
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0)
        {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Ticket Setting first',
            });
        } else
        {
            let message =
                selected.length == settingList.get().length
                    ? 'Do you want to delete all Ticket Setting ?'
                    : 'Do you want to delete selected Ticket Setting ?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const handleConfirmation = () =>
    {
        let deleteTickets = [];
        settingList.get().map((user) =>
        {

            if (user.selected === true)
            {
                deleteTickets.push(user.actualData.ticketMasterID);
            }
        });

        ApiHelper.post(APIURLConstants.DELETE_ALLSTAR_TICKETS_SETTING, {
            ids: deleteTickets.join(','),
            modifiedBy: userInfo.attach(Downgraded).get().userID,
        })
            .then((res) =>
            {
                if (res.data)
                {
                    setSnackBarProps({
                        snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Ticket Setting deleted successfully',
                    });
                    setShowSearchRec(false);
                    getSettingsList();
                }
            })
            .catch((error) =>
            {
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while deleting Ticket Setting List ';
                }
                setSnackBarProps({
                    snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    // const validateName = () => {
    //     const name = state.name.get() ?? '';
    //     if (name === '') {
    //         setNameErr('Please Enter Name');
    //         return { flag: 'false' };
    //     } else {
    //         setNameErr('');
    //     }
    // };
    // const ValidateDate = () => {
    //     const date = state.date.get() ?? '';
    //     if (date === '') {
    //         setDateError('Please Select Date');
    //         return { flag: 'false' };

    //     } else {
    //         setDateError('');
    //     }

    // };
    const saveTickets = (e) =>
    {
        e.preventDefault();

        // const tName = validateName();
        // const tDate = ValidateDate();
        // if (tName?.flag === 'false' || tDate?.flag === 'false') {
        //     return;
        // }
        // console.log("asdasd");
        let ticket = ticketInfo.attach(Downgraded).get()
        let mergedArray = [...dynamicFriTypePrice, ...dynamicSatTypePrice, ...dynamicSunTypePrice]

        const ticketData = {
            ticketMasterID: ticket != null ? ticket.ticketMasterID : 0,
            eventID: eventData.get().eventID,
            // name: state.name.get(),
            // date: new Date(state.date.attach(Downgraded).get()),
            createdBy: userInfo.userID.get(),
            prices: mergedArray
        }
        // console.log("ticketData", ticketData);
        // state.isDisable.set(true);
        ApiHelper.post(APIURLConstants.POST_ALLSTAR_TICKETS, ticketData)
            .then((res) =>
            {
                if (res.data)
                {
                    // state.isDisable.set(false);
                    setSnackBarProps({
                        snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: ticket != null ? 'Ticket Setting updated successfully' : 'Ticket Setting saved successfully',
                    });
                }
                openDialog.set(false);
                getSettingsList();
                resetState();
                // ticketInfo.set(null)
            })
            .catch((err) =>
            {
                console.log(err);
            });
    };


    // const handleDate = (values) => {
    //     state.set({
    //         ...state.get(),
    //         date: values
    //     })
    //     // setDateError('')
    // }
    // const onNameChange = (value) => {
    //     state.set({
    //         ...state.get(),
    //         name: value.target.value
    //     })
    //     // setNameErr('')
    // }

    const AddTypePrice = () =>
    {
        setDynamicFriTypePrice(s =>
        {
            return [
                ...s,
                {
                    ticketSubTypeID: 1,
                    ticketMasterID: 0,
                    ticketNightID: 1,
                    price: 0
                },

            ];
        });
    }
    const AddSatTypePrice = () =>
    {
        setDynamicSatTypePrice(s =>
        {
            return [
                ...s,
                {
                    ticketSubTypeID: 1,
                    ticketMasterID: 0,
                    ticketNightID: 2,
                    price: 0
                },

            ];
        });
    }
    const AddSunTypePrice = () =>
    {
        setDynamicSunTypePrice(s =>
        {
            return [
                ...s,
                {
                    ticketSubTypeID: 1,
                    ticketMasterID: 0,
                    ticketNightID: 3,
                    price: 0
                },

            ];
        });
    }
    // setDynamicSatTypePrice(satInputArr)

    const TicketTypeChange = e =>
    {
        const index = e.target.name;
        setDynamicFriTypePrice(s =>
        {
            const dynamicFriTypePrice = s.slice();
            dynamicFriTypePrice[index].ticketSubTypeID = Number(e.target.value);
            return dynamicFriTypePrice;
        });
    };
    const ticketPriceChange = e =>
    {
        const index = e.target.name;
        e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 7)
        setDynamicFriTypePrice(s =>
        {
            const dynamicFriTypePrice = s.slice();
            dynamicFriTypePrice[index].price = Number(e.target.value);
            return dynamicFriTypePrice;
        });
    }

    // const ticketSatNightChange = e => {
    //     const index = e.target.name;
    //     setDynamicFriTypePrice(s => {
    //         const dynamicFriTypePrice = s.slice();
    //         dynamicFriTypePrice[index].ticketNightID = Number(e.target.value);
    //         return dynamicFriTypePrice;
    //     });
    // }

    const TicketSatTypeChange = e =>
    {
        const index = e.target.name;
        setDynamicSatTypePrice(s =>
        {
            const dynamicSatTypePrice = s.slice();
            dynamicSatTypePrice[index].ticketSubTypeID = Number(e.target.value);
            return dynamicSatTypePrice;
        });
    };
    const ticketSatPriceChange = e =>
    {
        const index = e.target.name;
        e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 7)
        setDynamicSatTypePrice(s =>
        {
            const dynamicSatTypePrice = s.slice();
            dynamicSatTypePrice[index].price = Number(e.target.value);
            return dynamicSatTypePrice;
        });
    }
    const TicketSunTypeChange = e =>
    {
        const index = e.target.name;
        setDynamicSunTypePrice(s =>
        {
            const dynamicSunTypePrice = s.slice();
            dynamicSunTypePrice[index].ticketSubTypeID = Number(e.target.value);
            return dynamicSunTypePrice;
        });
    };
    const ticketSunPriceChange = e =>
    {
        const index = e.target.name;
        e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 7)
        setDynamicSunTypePrice(s =>
        {
            const dynamicSunTypePrice = s.slice();
            dynamicSunTypePrice[index].price = Number(e.target.value);
            return dynamicSunTypePrice;
        });
    }


    useEffect(() =>
    {
        if (flag)
        {
            setFlag(false)
        }
    }, [dynamicFriTypePrice, flag]);
    const removeTypePrice = (item, i) =>
    {
        let newValues = dynamicFriTypePrice;
        dynamicFriTypePrice.map((val) =>
        {
            if (JSON.stringify(val) === JSON.stringify(item))
            {
                newValues.splice(i, 1)
            }
        })
        try
        {
            if (setDynamicFriTypePrice(newValues))
            {
                setFlag(true)
                return true
            } else
            {
                setFlag(true)
            }
        } catch (error)
        {
            console.log(error);
        }

    }
    const removeSatTypePrice = (item, i) =>
    {
        let newValues = dynamicSatTypePrice;
        dynamicSatTypePrice.map((val) =>
        {
            if (JSON.stringify(val) === JSON.stringify(item))
            {
                newValues.splice(i, 1)
            }
        })
        try
        {
            if (setDynamicSatTypePrice(newValues))
            {
                setFlag(true)
                return true
            } else
            {
                setFlag(true)
            }
        } catch (error)
        {
            console.log(error);
        }

    }
    const removeSunTypePrice = (item, i) =>
    {
        let newValues = dynamicSunTypePrice;
        dynamicSunTypePrice.map((val) =>
        {
            if (JSON.stringify(val) === JSON.stringify(item))
            {
                newValues.splice(i, 1)
            }
        })
        try
        {
            if (setDynamicSunTypePrice(newValues))
            {
                setFlag(true)
                return true
            } else
            {
                setFlag(true)
            }
        } catch (error)
        {
            console.log(error);
        }
    }

    return (
        <>
            {openDialog.get() ? (
                <Box
                    className="otherContentBox"
                    component="form"
                    onSubmit={saveTickets}>
                    <Box
                        sx={{
                            flex: 1,
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                            <Box
                                sx={{
                                    alignItems: 'center',
                                    width: '100%',
                                }}>
                                {/* <TextField
                                    fullWidth
                                    required
                                    sx={{
                                        width: {
                                            xs: '100%',
                                            md: '45%',
                                        },
                                        marginTop: 2,
                                        marginRight: 2,
                                        marginBottom: 2,
                                    }}
                                    size="small"
                                    id="outlined-required"
                                    inputProps={{ maxLength: 50 }}
                                    value={state.name.get()}
                                    onBlur={validateName}
                                    onChange={(e) => {
                                        onNameChange(e),
                                            validateName()
                                    }}
                                    label="Name"
                                    error={
                                        nameErr.length > 0
                                            ? true
                                            : false
                                    }
                                    helperText={
                                        nameErr.length > 0
                                            ? nameErr
                                            : ''
                                    }
                                />
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="Date"
                                        value={state.date
                                            .attach(Downgraded)
                                            .get()}
                                        inputProps={{ readOnly: true }}
                                        minDate={new Date()}
                                        onBlur={ValidateDate}
                                        onChange={(newValue) => {
                                            handleDate(newValue),
                                                ValidateDate()
                                        }
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                fullWidth
                                                required
                                                size="small"
                                                autoComplete="off"
                                                onKeyDown={(e) =>
                                                    e.preventDefault()
                                                }
                                                sx={{
                                                    width: {
                                                        xs: '100%',
                                                        md: '45%',
                                                    },
                                                    marginTop: 2,
                                                    marginRight: 2,
                                                    marginBottom: 2,
                                                }}
                                                // error={false}
                                                error={
                                                    dateError.length > 0
                                                        ? true
                                                        : false
                                                }
                                                helperText={
                                                    dateError.length > 0
                                                        ? dateError
                                                        : ''
                                                }
                                            />
                                        )}
                                    />
                                </LocalizationProvider> */}
                            </Box>
                        </Box>
                    </Box>
                    <Box component="div" variant="h6"> Friday Night</Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            backgroundColor: '#f8f8f8',
                            flex: 1,
                            marginTop: '10px',
                        }}>
                        <Box flex={0.98}>
                            {dynamicFriTypePrice && dynamicFriTypePrice.length > 0 ? dynamicFriTypePrice.map((item, i) =>
                            {
                                return (
                                    <Box component="span" key={i}>
                                        <Select
                                            sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '40%',
                                                },
                                                marginTop: 1,
                                                marginRight: 2,
                                                marginLeft: 2,
                                                marginBottom: 1,
                                            }}
                                            name={i}
                                            size="small"
                                            value={item.ticketSubTypeID === 2 ? '2' : "1"}
                                            label="Type"
                                            defaultValue={0}
                                            // disabled={selectPreference > 0 ? false : props.disablePreference}
                                            // sx={{ minWidth: 80 }}
                                            onChange={(event) =>
                                            {
                                                TicketTypeChange(event)
                                            }
                                            }>
                                            <MenuItem value="2">Upper Bowl </MenuItem>
                                            <MenuItem value="1">Lower Bowl </MenuItem>
                                        </Select>
                                        {/* <Select
                                            sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '25%',
                                                },
                                                marginTop: 1,
                                                marginRight: 2,
                                                marginLeft: 2,
                                                marginBottom: 1,
                                            }}
                                            name={i}
                                            size="small"
                                            value={item.ticketNightID}
                                            label="Type"
                                            defaultValue={1}
                                            // disabled={selectPreference > 0 ? false : props.disablePreference}
                                            // sx={{ minWidth: 80 }}
                                            onChange={(event) => {
                                                ticketNightChange(event)
                                            }
                                            }>
                                            <MenuItem value="1">Friday Night </MenuItem>
                                            <MenuItem value="2">Saturday Night </MenuItem>
                                            <MenuItem value="3">Sunday Night </MenuItem>
                                        </Select> */}
                                        <TextField
                                            fullWidth
                                            type="number"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            required
                                            InputProps={{
                                                inputmode: 'numeric', min: 0,
                                            }}

                                            className={classes.inputNumber}
                                            sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '40%',
                                                },
                                                marginTop: 1,
                                                marginRight: 2,
                                                marginBottom: 1,
                                            }}
                                            name={i}
                                            size="small"
                                            id="outlined-required"
                                            // inputProps={{ maxLength: 5,  }}
                                            value={item.price === 0 ? "" : item.price}
                                            onChange={(e) =>
                                            {
                                                ticketPriceChange(e);
                                            }}
                                            label="Price"
                                        />
                                        {i !== 0 && <CancelIcon
                                            sx={{ color: 'red' }}
                                            onClick={() => { removeTypePrice(item, i) }}
                                        />}
                                    </Box>)
                            }) : null}
                            < AddCircleRoundedIcon
                                sx={{ color: '#008000' }}
                                onClick={AddTypePrice}
                            />
                        </Box>
                    </Box>
                    <Box component="div" variant="h6"> Saturday Night</Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            backgroundColor: '#f8f8f8',
                            flex: 1,
                            marginTop: '10px',
                        }}>

                        <Box flex={0.98}>
                            {dynamicSatTypePrice && dynamicSatTypePrice.length > 0 ? dynamicSatTypePrice.map((item, i) =>
                            {
                                return (
                                    <Box component="span" key={i}>
                                        <Select
                                            sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '40%',
                                                },
                                                marginTop: 1,
                                                marginRight: 2,
                                                marginLeft: 2,
                                                marginBottom: 1,
                                            }}
                                            name={i}
                                            size="small"
                                            value={item.ticketSubTypeID === 2 ? '2' : "1"}
                                            label="Type"
                                            defaultValue={0}
                                            // disabled={selectPreference > 0 ? false : props.disablePreference}
                                            // sx={{ minWidth: 80 }}
                                            onChange={(event) =>
                                            {
                                                TicketSatTypeChange(event)
                                            }
                                            }>
                                            <MenuItem value="2">Upper Bowl </MenuItem>
                                            <MenuItem value="1">Lower Bowl </MenuItem>
                                        </Select>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            required
                                            InputProps={{
                                                inputmode: 'numeric', min: 0,
                                            }}

                                            className={classes.inputNumber}
                                            sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '40%',
                                                },
                                                marginTop: 1,
                                                marginRight: 2,
                                                marginBottom: 1,
                                            }}
                                            name={i}
                                            size="small"
                                            id="outlined-required"
                                            // inputProps={{ maxLength: 5,  }}
                                            value={item.price === 0 ? "" : item.price}
                                            onChange={(e) =>
                                            {
                                                ticketSatPriceChange(e);
                                            }}
                                            label="Price"
                                        />
                                        {i !== 0 && <CancelIcon
                                            sx={{ color: 'red' }}
                                            onClick={() => { removeSatTypePrice(item, i) }}
                                        />}
                                    </Box>)
                            }) : null}
                            < AddCircleRoundedIcon
                                sx={{ color: '#008000' }}
                                onClick={AddSatTypePrice}
                            />
                        </Box>
                    </Box>
                    <Box component="div" variant="h6"> Sunday Night</Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            backgroundColor: '#f8f8f8',
                            flex: 1,
                            marginTop: '10px',
                        }}>

                        <Box flex={0.98}>
                            {dynamicSunTypePrice && dynamicSunTypePrice.length > 0 ? dynamicSunTypePrice.map((item, i) =>
                            {
                                return (
                                    <Box component="span" key={i}>
                                        <Select
                                            sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '40%',
                                                },
                                                marginTop: 1,
                                                marginRight: 2,
                                                marginLeft: 2,
                                                marginBottom: 1,
                                            }}
                                            name={i}
                                            size="small"
                                            value={item.ticketSubTypeID === 2 ? '2' : "1"}
                                            label="Type"
                                            defaultValue={0}
                                            // disabled={selectPreference > 0 ? false : props.disablePreference}
                                            // sx={{ minWidth: 80 }}
                                            onChange={(event) =>
                                            {
                                                TicketSunTypeChange(event)
                                            }
                                            }>
                                            <MenuItem value="2">Upper Bowl </MenuItem>
                                            <MenuItem value="1">Lower Bowl </MenuItem>
                                        </Select>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            required
                                            InputProps={{
                                                inputmode: 'numeric', min: 0,
                                            }}

                                            className={classes.inputNumber}
                                            sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '40%',
                                                },
                                                marginTop: 1,
                                                marginRight: 2,
                                                marginBottom: 1,
                                            }}
                                            name={i}
                                            size="small"
                                            id="outlined-required"
                                            // inputProps={{ maxLength: 5,  }}
                                            value={item.price === 0 ? "" : item.price}
                                            onChange={(e) =>
                                            {
                                                ticketSunPriceChange(e);
                                            }}
                                            label="Price"
                                        />
                                        {i !== 0 && <CancelIcon
                                            sx={{ color: 'red' }}
                                            onClick={() => { removeSunTypePrice(item, i) }}
                                        />}
                                    </Box>)
                            }) : null}
                            < AddCircleRoundedIcon
                                sx={{ color: '#008000' }}
                                onClick={AddSunTypePrice}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            flex: 0.3,
                            display: 'flex',
                            alignItems: 'end',
                            justifyContent: 'end',
                            marginTop: {
                                xs: 1,
                            },
                        }}>
                        <Button
                            variant="outlined"
                            onClick={() =>
                            {
                                openDialog.set(false);
                                resetState();
                                ticketInfo.set(null)
                            }}
                            style={{ fontSize: 13 }}>
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            type="submit"
                            // onClick={saveTickets}
                            style={{ fontSize: 13, marginLeft: 10 }}>
                            {ticketInfo.attach(Downgraded).get() != null ? 'Update' : 'Save'}
                        </Button>
                    </Box>
                </Box>
            ) : (
                <>
                    {loading.get() ? (
                        <Box
                            sx={
                                loading.get()
                                    ? {
                                        paddingTop: '20%',
                                        paddingBottom: '20%',
                                        textAlign: 'center',
                                    }
                                    : ''
                            }
                            className={loader}>
                            <CircularProgress />
                        </Box>
                    ) : settingList.get() ? (
                        <Box >
                            <DataTicketSettingList
                                data={settingList.attach(Downgraded).get()}
                                // onCheckSelect={onCheckSelect}
                                editRow={editTicket}
                                handleClick={redirectToCreate}
                                title={''}
                                buttonTitle={'Add'}
                                deleteRows={deleteSettingsList}
                                showSearch={true}
                                searchLabel={'Search'}
                                showSearchRec={showSearchRec}
                                setShowSearchRec={setShowSearchRec}
                                modPermission={FULL_PERMISSION}
                                toggleChange={toggleChange}
                            />
                        </Box>
                    ) : null}
                    {/* {openTemplateDialog.get() && (
                        <EditTemplate
                            open={openTemplateDialog.get()}
                            ticketInfo={ticketInfo.attach(Downgraded).get()}
                            title="Edit Template "
                            handleClose={closeEditTemplate}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            getSettingsList={getSettingsList}
                            settingList={true}
                        />
                    )} */}
                    {
                        <ConfirmationDialog
                            open={deleteConfirmation.get().open}
                            message={deleteConfirmation.get().message}
                            OkButtonText={deleteConfirmation.get().OkButtonText}
                            handleCnfClick={() =>
                                handleConfirmation(deleteConfirmation)
                            }
                            onCancelClick={() =>
                            {
                                deleteConfirmation.set({
                                    ...deleteConfirmation.get(),
                                    open: false,
                                });
                            }}></ConfirmationDialog>
                    }
                </>
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
        </>
    );
};
export default Settings;
